import React from "react";

const LightRedBorderedButton = ({ btnTxt, onClick, isMinWidth }) => {
  return (
    <button
      type="button"
      className={`light-bordered-red-btn ${isMinWidth ? "minWidth150" : ""}`}
      onClick={onClick}
    >
      {btnTxt}
    </button>
  );
};

export default LightRedBorderedButton;
